<template>
  <div class="big">
    <div class="page_title flex between">
      <span> 编辑短信推送</span>
      <el-button type="primary" style="width: 92px" @click="back"
        >返回</el-button
      >
    </div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div>
          <div class="title">基础配置</div>
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="120px"
            class="demo-ruleForm"
          >
            <el-form-item label="接收人员" required="">
              <el-radio-group
                v-model="ruleForm.send_type"
                @change="changeType"
                disabled=""
              >
                <el-radio :label="2">自定义</el-radio>
                <el-radio :label="3">excel导入</el-radio>
                <el-radio :label="1">sql配置</el-radio>

                <el-radio :label="4">用户群</el-radio>
                <el-radio :label="5">自定义用户群</el-radio>
                <el-radio :label="6">医生群</el-radio>
                <el-radio :label="7">自定义医生群</el-radio>
                <el-radio :label="8">医生关联业务</el-radio>
              </el-radio-group>
            </el-form-item>
            <!-- 自定义 -->
            <div v-if="ruleForm.send_type == 2" style="margin-top: -20px">
              <el-form-item prop="tel_string">
                <el-input
                  type="textarea"
                  :rows="6"
                  placeholder="请填写或粘贴接收短信的手机号，多个用英文逗号隔开"
                  v-model="ruleForm.tel_string"
                  style="width: 1000px"
                  disabled=""
                >
                </el-input>
              </el-form-item>
            </div>
            <el-form-item
              style="margin: 90px 0 20px; color: #ff5a37"
              v-if="ruleForm.send_type == 2"
            >
              注：自定义接收人员不支持短信内容插入变量
            </el-form-item>
            <div></div>
            <!-- SQL计算 -->
            <div style="margin: -10px 0 80px" v-if="ruleForm.send_type == 1">
              <el-form-item label="SQL规则" prop="sql_string">
                <el-input
                  type="textarea"
                  :rows="4"
                  placeholder="查询的结果必须返回手机号，若有变量时，查询的结果可返回变量值"
                  v-model="ruleForm.sql_string"
                  style="width: 1000px"
                  disabled=""
                >
                </el-input>
              </el-form-item>
            </div>
            <!-- 导入创建 -->
            <div v-if="ruleForm.send_type == 3" style="margin-top: -10px">
              <el-form-item label="已上传文件" v-if="file_name">
                <span style="color: #666">{{ file_name }}</span>
              </el-form-item>
            </div>

            <!-- 用户群 -->
            <div
              v-if="ruleForm.send_type == 4"
              style="margin-top: -20px; padding-left: 66px"
            >
              <el-form-item label="标签类型" prop="label_from">
                <el-radio-group v-model="ruleForm.label_from" disabled>
                  <el-radio :label="1">手动标签</el-radio>
                  <el-radio :label="4">自动标签</el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item label="标签" prop="label_id">
                <el-select
                  v-model="ruleForm.label_category_type"
                  placeholder="请选择"
                  style="width: 200px"
                  @change="changeLabel"
                  disabled
                  size="small"
                >
                  <el-option
                    v-for="item in labelTypeList"
                    :key="item.label_type"
                    :label="item.label_type_name"
                    :value="item.label_type"
                  >
                  </el-option>
                </el-select>
                <el-select
                  v-if="ruleForm.label_category_type != ''"
                  v-model="ruleForm.label_id"
                  placeholder="请选择"
                  style="width: 200px; margin-left: 10px"
                  size="small"
                >
                  <el-option
                    v-for="item in labelList"
                    :key="item.label_id"
                    :label="item.label_name"
                    :value="item.label_id"
                  >
                  </el-option>
                </el-select>
                <span style="margin-left: 10px"
                  >标签总人数：{{ userNum }}人</span
                >
              </el-form-item>
            </div>
            <!-- 自定义用户群 -->
            <div
              v-if="ruleForm.send_type == 5"
              style="margin-top: -20px; padding-left: 66px"
            >
              <el-form-item
                label=""
                prop="param_detail"
                style="margin-top: -20px"
                class="param-detail"
              >
                <div
                  v-for="(item, index) in ruleForm.param_detail"
                  :key="index"
                  class="flex user-group"
                >
                  <el-select
                    v-model="item.field"
                    placeholder="请选择"
                    disabled
                    @change="
                      changeUserAndDoctorGroupField(
                        item.field,
                        index,
                        'userGroupDataList'
                      )
                    "
                    style="width: 200px"
                  >
                    <el-option
                      v-for="item in userGroupDataList"
                      :key="item.key"
                      :label="item.value"
                      :value="item.key"
                      :disabled="item.disabled"
                    >
                    </el-option>
                  </el-select>
                  <span>&nbsp;{{ item.compute }}&nbsp;</span>
                  <!-- 输入框 -->
                  <template v-if="item.userOrDoctorGroupType == 1">
                    <el-input
                      placeholder="请输入内容"
                      v-model="item.value"
                      clearable
                      style="width: 400px"
                      disabled
                    >
                    </el-input>
                  </template>
                  <!-- 时间范围 -->
                  <template v-if="item.userOrDoctorGroupType == 2">
                    <el-date-picker
                      v-model="item.times"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      style="width: 400px"
                      disabled
                    >
                    </el-date-picker>
                  </template>
                  <!-- 选择框 -->
                  <template v-if="item.userOrDoctorGroupType == 3">
                    <el-select
                      v-model="item.value"
                      placeholder="请选择"
                      style="width: 400px"
                      disabled
                    >
                      <el-option
                        v-for="j in item.userOrDoctorGroupList"
                        :key="j.key"
                        :label="j.value"
                        :value="j.key"
                      >
                      </el-option>
                    </el-select>
                  </template>

                  <div v-if="index == ruleForm.param_detail.length - 1">
                    <span style="margin-left: 20px">人数：{{ userNum }}人</span>
                  </div>
                </div>
              </el-form-item>
            </div>

            <!-- 医生群 -->
            <div
              v-if="ruleForm.send_type == 6"
              style="margin-top: -20px; padding-left: 66px"
            >
              <el-form-item label="标签类型" prop="label_from">
                <el-radio-group v-model="ruleForm.label_from" disabled>
                  <el-radio :label="2">手动标签</el-radio>
                  <el-radio :label="3">自动标签</el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item label="标签" prop="label_id">
                <el-select
                  v-model="ruleForm.label_category_type"
                  placeholder="请选择"
                  style="width: 200px"
                  @change="changeLabel"
                  disabled
                  size="small"
                >
                  <el-option
                    v-for="item in labelTypeList"
                    :key="item.label_type"
                    :label="item.label_type_name"
                    :value="item.label_type"
                  >
                  </el-option>
                </el-select>
                <el-select
                  v-if="ruleForm.label_category_type != ''"
                  v-model="ruleForm.label_id"
                  placeholder="请选择"
                  style="width: 200px; margin-left: 10px"
                  size="small"
                  disabled
                >
                  <el-option
                    v-for="item in labelList"
                    :key="item.label_id"
                    :label="item.label_name"
                    :value="item.label_id"
                  >
                  </el-option>
                </el-select>
                <span style="margin-left: 10px"
                  >标签总人数：{{ userNum }}人</span
                >
              </el-form-item>
            </div>
            <!-- 自定义医生群 -->
            <div
              v-if="ruleForm.send_type == 7"
              style="margin-top: -20px; padding-left: 66px"
            >
              <el-form-item
                label=""
                prop="param_detail"
                style="margin-top: -20px"
                class="param-detail"
              >
                <div
                  v-for="(item, index) in ruleForm.param_detail"
                  :key="index"
                  class="flex user-group"
                >
                  <el-select
                    v-model="item.field"
                    placeholder="请选择"
                    disabled
                    @change="
                      changeUserAndDoctorGroupField(
                        item.field,
                        index,
                        'doctorGroupDataList'
                      )
                    "
                    style="width: 200px"
                  >
                    <el-option
                      v-for="item in doctorGroupDataList"
                      :key="item.key"
                      :label="item.value"
                      :value="item.key"
                      :disabled="item.disabled"
                    >
                    </el-option>
                  </el-select>
                  <span>&nbsp;=&nbsp;</span>
                  <!-- 输入框 -->
                  <template v-if="item.userOrDoctorGroupType == 1">
                    <el-input
                      placeholder="请输入内容"
                      v-model="item.value"
                      clearable
                      style="width: 400px"
                      disabled
                    >
                    </el-input>
                  </template>
                  <!-- 时间范围 -->
                  <template v-if="item.userOrDoctorGroupType == 2">
                    <el-date-picker
                      v-model="item.times"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      style="width: 400px"
                      disabled
                    >
                    </el-date-picker>
                  </template>
                  <!-- 选择框 -->
                  <template v-if="item.userOrDoctorGroupType == 3">
                    <el-select
                      v-model="item.value"
                      placeholder="请选择"
                      style="width: 400px"
                      multiple
                      disabled
                    >
                      <el-option
                        v-for="j in item.userOrDoctorGroupList"
                        :key="j.key"
                        :label="j.value"
                        :value="j.key"
                      >
                      </el-option>
                    </el-select>
                  </template>
                  <!-- 区间 -->
                  <template v-if="item.userOrDoctorGroupType == 4">
                    <el-input-number
                      v-model="item.minNum"
                      :min="0"
                      :precision="0"
                      :controls="false"
                      style="width: 192px"
                      disabled
                    ></el-input-number>
                    &nbsp;~&nbsp;
                    <el-input-number
                      v-model="item.maxNum"
                      :min="0"
                      :precision="0"
                      :controls="false"
                      style="width: 192px"
                      disabled
                    ></el-input-number>
                  </template>

                  <div v-if="index == ruleForm.param_detail.length - 1">
                    <span style="margin-left: 20px">人数：{{ userNum }}人</span>
                  </div>
                </div>
              </el-form-item>
            </div>

            <!-- 医生关联业务1 -->
            <div
              v-if="ruleForm.send_type == 8"
              style="margin-top: -20px; padding-left: 66px"
            >
              <el-form-item
                label="医生来源"
                prop="check_type"
                class="doctor-import"
              >
                <el-radio-group v-model="ruleForm.check_type" disabled>
                  <el-radio :label="1">导入医生</el-radio>
                  <el-radio :label="2">自定义医生</el-radio>
                  <el-radio :label="3">按标签添加</el-radio>
                </el-radio-group>
                <!-- 导入医生 -->
                <div v-if="ruleForm.check_type == 1">
                  <div style="padding-left: 130px" v-if="file_name">
                    <span>上传文件：</span>
                    <span style="color: #666">{{ file_name }}</span>
                  </div>
                </div>
                <!-- 自定义医生 -->
                <div v-if="ruleForm.check_type == 2">
                  <el-form-item prop="tel_string" class="tel-tips-form">
                    <el-input
                      type="textarea"
                      :rows="6"
                      placeholder="请填写或粘贴接收短信的手机号，多个用英文逗号隔开"
                      v-model="ruleForm.tel_string"
                      style="width: 1000px"
                      disabled
                    >
                    </el-input>
                  </el-form-item>
                </div>
                <!-- 按标签添加 -->
                <div v-if="ruleForm.check_type == 3">
                  <el-form-item label="标签类型" prop="label_from">
                    <el-radio-group
                      v-model="ruleForm.label_from"
                      @change="changeLabelFrom"
                      disabled
                    >
                      <el-radio :label="2">手动标签</el-radio>
                      <el-radio :label="3">自动标签</el-radio>
                    </el-radio-group>
                  </el-form-item>

                  <el-form-item label="标签" prop="label_id">
                    <el-select
                      v-model="ruleForm.label_category_type"
                      placeholder="请选择"
                      style="width: 200px"
                      @change="changeLabel"
                      size="small"
                      disabled
                    >
                      <el-option
                        v-for="item in labelTypeList"
                        :key="item.label_type"
                        :label="item.label_type_name"
                        :value="item.label_type"
                      >
                      </el-option>
                    </el-select>
                    <el-select
                      v-if="ruleForm.label_category_type != ''"
                      v-model="ruleForm.label_id"
                      placeholder="请选择"
                      style="width: 200px; margin-left: 10px"
                      size="small"
                      disabled
                    >
                      <!-- @change="getNum" -->
                      <el-option
                        v-for="item in labelList"
                        :key="item.label_id"
                        :label="item.label_name"
                        :value="item.label_id"
                      >
                      </el-option>
                    </el-select>
                    <!-- <span style="margin-left: 10px"
                      >标签总人数：{{ userNum }}人</span
                    > -->
                  </el-form-item>
                </div>
              </el-form-item>
            </div>

            <el-form-item label="短信内容" prop="sms_content">
              <el-input
                type="textarea"
                :rows="6"
                placeholder="请输入内容"
                v-model="ruleForm.sms_content"
                maxlength="500"
                show-word-limit
                style="width: 1000px"
              >
              </el-input>
              <div style="text-align: right; width: 1000px">
                <el-button type="primary" @click="importTem" size="mini"
                  >导入模板内容</el-button
                >
                <el-button
                  type="primary"
                  @click="addVariable"
                  size="mini"
                  v-if="ruleForm.send_type != 2"
                  >插入变量</el-button
                >
              </div>
              <div style="margin: 0 0 20px; color: #ff5a37">
                注：当前为营销类短信，请注意在短信内容尾部添加拒收回复等内容。
              </div>
            </el-form-item>
            <div class="title" style="margin-top: 140px">其他配置</div>

            <el-form-item label="发送周期" prop="sms_cycle" required="">
              <el-radio-group v-model="ruleForm.sms_cycle" disabled="">
                <div class="align-center">
                  <el-radio :label="1">仅本次</el-radio>
                  <el-radio-group
                    v-model="ruleForm.timing_type"
                    style="margin-left: 30px"
                    v-if="ruleForm.sms_cycle == 1"
                    disabled=""
                  >
                    <el-radio :label="0">立即发送</el-radio>
                    <el-radio :label="1"
                      >定时发送
                      <el-date-picker
                        v-model="ruleForm.time"
                        type="datetime"
                        placeholder="选择日期时间"
                        value-format="yyyy-MM-dd HH:mm"
                        format="yyyy-MM-dd HH:mm"
                        disabled=""
                      >
                      </el-date-picker>
                    </el-radio>
                  </el-radio-group>
                </div>
                <div style="margin: 20px 0">
                  <el-radio :label="2">每天</el-radio>
                  <el-time-picker
                    v-if="ruleForm.sms_cycle == 2"
                    v-model="ruleForm.day_time"
                    value-format="HH:mm"
                    format="HH:mm"
                    style="margin-left: 10px; width: 150px"
                    disabled=""
                  >
                  </el-time-picker>
                </div>
                <div>
                  <el-radio :label="3">每周</el-radio>
                  <el-select
                    v-if="ruleForm.sms_cycle == 3"
                    v-model="ruleForm.week_day"
                    placeholder="请选择"
                    style="margin-left: 10px; width: 100px"
                    disabled=""
                  >
                    <el-option
                      v-for="item in weekList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                  <el-time-picker
                    v-if="ruleForm.sms_cycle == 3"
                    v-model="ruleForm.week_time"
                    value-format="HH:mm"
                    format="HH:mm"
                    style="margin-left: 10px; width: 150px"
                    disabled=""
                  >
                  </el-time-picker>
                </div>
                <div style="margin: 20px 0">
                  <el-radio :label="4">每月</el-radio>
                  <el-select
                    v-if="ruleForm.sms_cycle == 4"
                    v-model="ruleForm.month_day"
                    placeholder="请选择"
                    style="margin-left: 10px; width: 100px"
                    disabled=""
                  >
                    <el-option
                      v-for="item in 31"
                      :key="item"
                      :label="item + '号'"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                  <el-time-picker
                    v-if="ruleForm.sms_cycle == 4"
                    v-model="ruleForm.month_time"
                    value-format="HH:mm"
                    format="HH:mm"
                    style="margin-left: 10px; width: 150px"
                    disabled=""
                  >
                  </el-time-picker>
                </div>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="短信签名"
              prop="sms_sign"
              style="margin-top: 140px"
              required=""
            >
              <el-select
                v-model="ruleForm.sms_sign"
                placeholder="请选择"
                disabled=""
              >
                <el-option
                  v-for="item in signList"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div style="text-align: center">
            <el-button
              style="width: 92px"
              type="primary"
              @click="submit('ruleForm')"
              >提交</el-button
            >
            <el-button style="width: 92px" @click="back">取消</el-button>
          </div>
        </div>
      </div>
    </div>
    <!-- 导入模板内容 -->
    <el-dialog
      title="导入模板内容"
      :visible.sync="temdata"
      width="700px"
      :close-on-click-modal="false"
    >
      <div style="padding: 20px">
        <div class="searchbox">
          <div class="item">
            <span>模板名称</span>
            <el-input
              v-model="content"
              size="small"
              placeholder="请输入短信内容"
              style="width: 300px; margin-left: 10px"
              clearable
            ></el-input>
            <el-button
              size="small"
              style="
                background-color: #eceff2;
                color: #747981;
                margin-left: 10px;
              "
              @click="getTemData"
              >查询</el-button
            >
          </div>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="temData"
            tooltip-effect="dark"
            style="width: 100%"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column width="50">
              <template slot-scope="scope">
                <el-checkbox
                  v-model="scope.row.check"
                  @change="
                    (value) => {
                      return changeCheck(value, scope.row);
                    }
                  "
                ></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column
              label="模板名称"
              prop="sms_title"
              width="200"
            ></el-table-column>
            <el-table-column label="模板内容" prop="sms_content">
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-pagination
            @size-change="temSizeChange"
            @current-change="temCurrentChange"
            :current-page="temPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="temSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="temNum"
            style="margin: 20px 0 30px"
          ></el-pagination>
        </div>
        <div style="text-align: center">
          <span slot="footer" class="dialog-footer">
            <el-button
              type="primary"
              @click="importContent"
              style="width: 92px"
              size="medium"
              >确定</el-button
            >
            <el-button
              plain
              @click="temdata = false"
              style="width: 92px"
              size="medium"
              >取 消</el-button
            >
          </span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import dayjs from "dayjs";
import common from "@/api/common.js";
import _ from "lodash";
import constant from "../../../service/common/constant";
import { shortMessageMixin } from "./mixins";

export default {
  mixins: [shortMessageMixin],
  data() {
    return {
      sms_task_id: this.$route.query.sms_task_id,
      signList: [],
      file_name: "",
      weekList: [
        {
          label: "周一",
          value: 1,
        },
        {
          label: "周二",
          value: 2,
        },
        {
          label: "周三",
          value: 3,
        },
        {
          label: "周四",
          value: 4,
        },
        {
          label: "周五",
          value: 5,
        },
        {
          label: "周六",
          value: 6,
        },
        {
          label: "周日",
          value: 7,
        },
      ],
      uploadExtraData: {
        img_type: 6,
        suffix: ".jpg",
      },
      ruleForm: {
        send_type: 2,
        tel_string: "",
        sql_string: "",
        sms_content: "",
        sms_cycle: 1,
        timing_type: 0,
        time: "",
        week_day: "",
        month_day: "",
        day_time: "",
        week_time: "",
        month_time: "",
        file_url: "",
        sms_sign: "【歧黄医官】",
        label_from: 2,
        label_category_type: "",
        label_id: "",
        param_detail: [],
      },
      rules: {
        label_name: [
          {
            required: true,
            message: "请输入标签名称",
            trigger: "blur",
          },
        ],
        sql_string: [
          { required: true, message: "请输入SQL规则", trigger: "blur" },
        ],
        tel_string: [
          {
            required: true,
            message: "请填写或粘贴接收短信的手机号",
            trigger: "blur",
          },
        ],
        sms_content: [
          { required: true, message: "请输入短信内容", trigger: "blur" },
        ],
      },
      userNum: 0,
      content: "",
      temData: [],
      temPage: 1,
      temSize: 10,
      temNum: 0,
      temdata: false,
      a: 0,
      checkContent: "",
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    uploadUrl() {
      if (process.env.NODE_ENV == "development") {
        // 本地开发使用 api 前缀
        return "/api/platform/upload/uploadFile";
      } else {
        return "/platform/upload/uploadFile";
      }
    },
    uploadHeaders: function () {
      return Object.assign(
        {},
        _.pick(constant.HEADERS, ["version", "platform"]),
        {
          timestamp: Date.now(),
          token: this.$store.state.login.headerToken,
        }
      );
    },
  },
  created() {
    this.platformSmsSignList();
    this.getDetail();
  },
  methods: {
    //获取详情
    getDetail() {
      let sms_task_id = this.$route.query.sms_task_id;
      this.axios
        .post("platform/patient/getPlatformSmsTaskInfo", { sms_task_id })
        .then((res) => {
          if (res.code == 0) {
            let info = res.data.info;
            // 人数
            this.userNum = info.people_num;
            this.ruleForm = {
              sms_task_id: this.$route.query.sms_task_id,
              send_type: info.send_type,
              sms_content: info.sms_content,
              sms_cycle: info.sms_cycle,
              sms_sign: info.sms_sign,
              timing_type: 0,
              label_from: info.label_from,
              label_category_type: info.label_category_type,
              label_id: info.label_id,
              check_type: info.check_type,
            };
            this.ruleForm.param_detail = info.param_detail.map((item) => {
              let obj = {
                times: "",
                userOrDoctorGroupType: item.type,
                userOrDoctorGroupList: [],
                minNum: undefined,
                maxNum: undefined,
              };
              switch (item.type) {
                case 2:
                  let start = dayjs
                    .unix(item.action_start_time)
                    .format("YYYY-MM-DD");
                  let end = dayjs
                    .unix(item.action_end_tine)
                    .format("YYYY-MM-DD");
                  obj["times"] = [start, end];
                  break;
                case 4:
                  let parts = item.value.split("-");
                  obj["minNum"] = parts[0];
                  obj["maxNum"] = parts[1];
                  break;
              }
              item = Object.assign({}, item, obj);
              return item;
            });
            //sql配置
            if (info.send_type == 1) {
              this.ruleForm.sql_string = info.sql_string;
            }
            //自定义
            if (info.send_type == 2) {
              this.ruleForm.tel_string = info.sql_string;
            }
            //excel文件导入
            if (info.send_type == 3) {
              this.ruleForm.file_url = info.sql_string;
              this.file_name = info.file_name;
            }
            //医生关联业务excel文件导入
            if (info.send_type == 8) {
              if (this.ruleForm.check_type == 1) {
                this.ruleForm.file_url = info.sql_string;
                this.file_name = info.file_name;
              } else {
                this.ruleForm.tel_string = info.sql_string;
              }
            }
            //仅本次
            if (info.sms_cycle == 1) {
              if (info.timing_time) {
                this.ruleForm.time = dayjs
                  .unix(info.send_time)
                  .format("YYYY-MM-DD HH:mm");
                this.ruleForm.timing_type = 1;
              }
            }
            //每天
            if (info.sms_cycle == 2) {
              this.ruleForm.day_time = dayjs
                .unix(info.send_time)
                .format("HH:mm");
            }
            //每周
            if (info.sms_cycle == 3) {
              this.ruleForm.week_day = info.day;
              this.ruleForm.week_time = dayjs
                .unix(info.send_time)
                .format("HH:mm");
            }
            //每月
            if (info.sms_cycle == 4) {
              this.ruleForm.month_day = info.day;
              this.ruleForm.month_time = dayjs
                .unix(info.send_time)
                .format("HH:mm");
            }
            switch (info.send_type) {
              case 4: //用户群
                this.getLabelType();
                break;
              case 5: //自定义用户群
                this.getUserGroupDataList();
                break;
              case 6: //医生群
                this.getLabelType();
                break;
              case 7: //自定义医生群
                this.getDoctorGroupDataList();
                break;
            }
          }
        });
    },
    //获取签名
    platformSmsSignList() {
      this.axios.post("platform/patient/platformSmsSignList").then((res) => {
        if (res.code == 0) {
          this.signList = res.data.list;
        }
      });
    },
    //导入模板
    importTem() {
      this.getTemData();
      this.temdata = true;
    },
    //获取导入模板列表
    getTemData() {
      let data = {
        content: this.content,
        page: this.temPage,
        pageNumber: this.temSize,
      };
      this.axios
        .post("platform/patient/platformSmsTaskTcmList", data)
        .then((res) => {
          if (res.code == 0) {
            this.temData = res.data.list.map((item) => {
              item.check = false;
              return item;
            });
            this.temNum = res.data.total;
          }
        });
    },
    //每页数据的条数
    temSizeChange(size) {
      this.temSize = size;
      this.getTemData();
    },
    //当前第几页
    temCurrentChange(currentPage) {
      this.temPage = currentPage;
      this.getTemData();
    },
    changeCheck(value, row) {
      if (value) {
        this.temData.forEach((item) => {
          item.check = false;
        });
        row.check = true;
        this.checkContent = row.sms_content;
      }
    },
    //导入模板
    importContent() {
      if (this.ruleForm.sms_content) {
        this.ruleForm.sms_content += this.checkContent;
      } else {
        this.ruleForm.sms_content = this.checkContent;
      }
      this.temdata = false;
    },
    //插入变量
    addVariable() {
      var regex = new RegExp(/\$\{.+?\}/, "g");
      var result = this.ruleForm.sms_content.match(regex);
      if (result && result.length >= 5) {
        this.$message.error("最多可插入5个变量");
        return false;
      }
      this.ruleForm.sms_content = this.ruleForm.sms_content + "${ }";
    },
    //提交创建
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          //自定义
          let data = this.ruleForm;
          var regex = new RegExp(/\$\{.+?\}/, "g");
          var result = data.sms_content.match(regex);
          if (result && result.length > 5) {
            this.$message.error("最多可插入5个变量");
            return false;
          }
          data.sms_content = data.sms_content.replace(/[ ]/g, "");
          data.sub_type = 1;
          if (this.ruleForm.send_type == 2) {
            data.sql_string = this.ruleForm.tel_string;
          }
          //sql配置
          if (this.ruleForm.send_type == 1) {
            // data = this.ruleForm;
          }
          //excel文件导入
          if (this.ruleForm.send_type == 3) {
            if (!data.file_url) {
              this.$message.error("请上传文件");
              return false;
            }
            data.file_name = this.file_name;
            data.sql_string = data.file_url;
          }
          //医生关联业务excel文件导入
          if (this.ruleForm.send_type == 8) {
            if (this.ruleForm.check_type == 1) {
              if (!data.file_url) {
                this.$message.error("请上传文件");
                return false;
              }
              data.file_name = this.file_name;
              data.sql_string = data.file_url;
            } else {
              data.sql_string = this.ruleForm.tel_string;
            }
          }
          //仅本次
          if (data.sms_cycle == 1) {
            if (data.timing_type == 1) {
              if (!data.time) {
                this.$message.error("请选择定时发送时间");
                return false;
              } else {
                data.timing_time = data.time;
                data.send_time = data.time;
              }
            } else {
              data.timing_time = 0;
            }
          }
          //每天
          if (data.sms_cycle == 2) {
            let now = dayjs(new Date()).format("YYYY-MM-DD ");
            if (!data.day_time) {
              this.$message.error("请选择每天发送时间");
              return false;
            } else {
              data.send_time = now + data.day_time;
            }
          }
          //每周
          if (data.sms_cycle == 3) {
            let now = dayjs(new Date()).format("YYYY-MM-DD ");
            if (!data.week_time || !data.week_day) {
              this.$message.error("请选择每周发送时间");
              return false;
            } else {
              data.day = data.week_day;
              data.send_time = now + data.week_time;
            }
          }
          //每月
          if (data.sms_cycle == 4) {
            let now = dayjs(new Date()).format("YYYY-MM-DD ");
            if (!data.month_time || !data.month_day) {
              this.$message.error("请选择每月发送时间");
              return false;
            } else {
              data.day = data.month_day;
              data.send_time = now + data.month_time;
            }
          }

          this.axios
            .post("platform/patient/updatePlatformSmsTask", data)
            .then((res) => {
              if (res.code == 0) {
                if (!res.data.count) {
                  this.$confirm("请输入有效的接收人员", "提示", {
                    confirmButtonText: "确定",
                    showCancelButton: false,
                  })
                    .then(() => {})
                    .catch(() => {});
                  return;
                }
                this.$confirm(
                  `当前短信发送人数${res.data.count}人，短信内容为：${data.sms_content}`,
                  "提示",
                  {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    closeOnClickModal: false,
                  }
                )
                  .then(() => {
                    data.sub_type = 2;
                    this.axios
                      .post("platform/patient/updatePlatformSmsTask", data)
                      .then((res) => {
                        if (res.code == 0) {
                          this.$message.success("保存成功");
                          this.back();
                        }
                      });
                  })
                  .catch(() => {});
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    changeType(type) {
      if (type != 1) {
        this.ruleForm.content = "";
      }
    },
    back() {
      history.back();
    },
    refresh() {},
    getLabelType() {
      return new Promise(async (resolve) => {
        const loading = this.$loading();
        let params = {
          type: this.ruleForm.label_from,
        };
        let { data } = await common.getLabelType(params);
        this.labelTypeList = data.list;
        if (this.ruleForm.label_category_type == 0) {
          this.ruleForm.label_category_type = data.list[0].label_type;
          this.ruleForm.platform_label_id = "";
          this.$nextTick(() => {
            this.$refs["ruleForm"].clearValidate();
          });
        }
        loading.close();
        resolve(data);
        this.getLabel();
      });
    },
    getLabel() {
      return new Promise(async (resolve) => {
        const loading = this.$loading();
        let params = {
          type: this.ruleForm.label_from,
          label_type: this.ruleForm.label_category_type,
        };

        let { data } = await common.getLabel(params);
        this.labelList = data.list;
        loading.close();
        resolve(data);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  text-align: left;
  padding-bottom: 20px;
}
.title {
  font-size: 16px;
  font-weight: 700;
  padding: 20px 0 20px 70px;
}
.doctor-import {
  ::v-deep .el-form-item__content {
    height: auto;
  }
}
.param-detail {
  height: auto;
  ::v-deep .el-form-item__content {
    height: auto;
    .user-group {
      padding: 10px 0;
    }
  }
}
.sms-content {
  .el-form-item__content {
    height: auto;
  }
}
</style>
